import React from 'react';
import UniversalCard from '../../../shared/UniversalCard';
import MockDataWrapper from '../../../shared/MockDataWrapper';
import './RentalUnitsCard.scss';

interface RentalUnitsStats {
  residential: number;
  commercial: number;
  industrial: number;
  mixed: number;
}

interface RentalUnitsData {
  id: string;
  totalUnits: number;
  stats: RentalUnitsStats;
}

interface RentalUnitsCardProps {
  data?: RentalUnitsData[];
  onTenancyOverviewClick?: () => void;
  className?: string;
}

// Моковые данные по умолчанию
const mockRentalUnitsData: RentalUnitsData[] = [
  {
    id: '2',
    totalUnits: 8,
    stats: {
      residential: 5,
      commercial: 2,
      industrial: 1,
      mixed: 0,
    },
  },
];

// Иконка дома
const houseIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.667 16V11H15.333V16M3 9.7L13 2L23 9.7V20.8C23 21.3835 22.766 21.9431 22.349 22.3556C21.932 22.7682 21.367 23 20.778 23H5.222C4.633 23 4.068 22.7682 3.651 22.3556C3.234 21.9431 3 21.3835 3 20.8V9.7Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Функция рендера содержимого карточки арендных единиц
const renderRentalUnitsContent = (
  item: any,
  index: number,
  onTenancyOverviewClick?: () => void,
) => {
  const units = item as RentalUnitsData;

  return (
    <>
      <div className="RentalUnitsCard__main-number">{units.totalUnits}</div>

      <div className="RentalUnitsCard__substats">
        <div className="RentalUnitsCard__column">
          <div className="RentalUnitsCard__substat">
            <span className="RentalUnitsCard__label">Residential:</span>
            <span className="RentalUnitsCard__value">
              {units.stats.residential}
            </span>
          </div>
          <div className="RentalUnitsCard__substat">
            <span className="RentalUnitsCard__label">Commercial:</span>
            <span className="RentalUnitsCard__value">
              {units.stats.commercial}
            </span>
          </div>
        </div>

        <div className="RentalUnitsCard__column">
          <div className="RentalUnitsCard__substat">
            <span className="RentalUnitsCard__label">Industrial:</span>
            <span className="RentalUnitsCard__value">
              {units.stats.industrial}
            </span>
          </div>
          <div className="RentalUnitsCard__substat">
            <span className="RentalUnitsCard__label">Mixed:</span>
            <span className="RentalUnitsCard__value">{units.stats.mixed}</span>
          </div>
        </div>
      </div>

      <div className="RentalUnitsCard__link" onClick={onTenancyOverviewClick}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 10.8V8M8 5.2H8.007M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
            stroke="#105E96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span>Tenancy overview</span>
      </div>
    </>
  );
};

const RentalUnitsCard: React.FC<RentalUnitsCardProps> = ({
  data,
  onTenancyOverviewClick,
  className = '',
}) => {
  // Определяем, используются ли мок-данные
 // const isMockData = !data;
  const displayData = data || mockRentalUnitsData;

  // Создаем функцию рендера с замыканием для передачи onTenancyOverviewClick
  const renderContent = (item: any, index: number) =>
    renderRentalUnitsContent(item, index, onTenancyOverviewClick);

  return (

      <UniversalCard
        title="Rental Units"
        backgroundColor="#5CB2EF"
        icon={houseIcon}
        data={displayData}
        renderContent={renderContent}
      />

  );
};

export default RentalUnitsCard;
